<template>
  <b-container fluid>
    <esg-base-card title="협력사 배출량 관리"
                   :footer="false">
      <template #default>
        <b-container class="my-4 px-0">
          <b-row align-h="start">
            <b-col md="6"
                   lg="3">
              <esg-single-score-card title="총배출량"
                                     :score="1230"
                                     score-unit="tCO2e"
                                     :diff="-6.4"
                                     labelColor="#3F84E5"
                                     diff-unit="%"/>
            </b-col>
            <b-col md="6"
                   lg="3"
                   class="mt-3 mt-md-0">
              <esg-single-score-card title="업스트림 배출량"
                                     :score="580"
                                     score-unit="tCO2e"
                                     :diff="6.4"
                                     :labelColor='"blue"'
                                     diff-unit="%"/>
            </b-col>
            <b-col md="6"
                   lg="3"
                   class="mt-3 mt-lg-0">
              <esg-single-score-card title="다운스트림 배출량"
                                     :score="750"
                                     score-unit="tCO2e"
                                     :diff="3"
                                     :labelColor='"blue"'
                                     diff-unit="%"/>
            </b-col>
          </b-row>
          <b-row align-h="start"
                 class="mt-3">
            <b-col md="6"
                   lg="3">
              <esg-single-score-card title="협력사수"
                                     :score="249"
                                     score-unit="사"
                                     :diff="-6.4"
                                     :labelColor='"yellow"'
                                     diff-unit="%"/>
            </b-col>
            <b-col md="6"
                   lg="3">
              <esg-single-score-card title="업스트림 보고사수"
                                     :score="81"
                                     score-unit="사"
                                     :diff="6.4"
                                     :labelColor='"yellow"'
                                     diff-unit="%"/>
            </b-col>
            <b-col md="6"
                   lg="3"
                   class="mt-3 mt-lg-0">
              <esg-single-score-card title="다운스트림 보고사수"
                                     :score="92"
                                     score-unit="사"
                                     :diff="3"
                                     :labelColor='"yellow"'
                                     diff-unit="%"/>
            </b-col>
          </b-row>
          <b-row align-h="start"
                 class="mt-3">
            <b-col md="6"
                   lg="3"
                   class="mt-3 mt-lg-0">
              <esg-single-score-card title="LCA 협력사 수"
                                     :score="122"
                                     score-unit="사"
                                     :diff="-6.4"
                                     :labelColor='"red"'
                                     diff-unit="%"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <esg-partner-quarterly-emission/>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12"
                   class="mt-3 mt-lg-0">
              <esg-partner-data-grid/>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </esg-base-card>
  </b-container>
</template>

<script>
import EsgSingleScoreCard from "@/components/esg/base/EsgSingleScoreCard.vue";
import EsgCardHeader from "@/components/esg/base/EsgBaseCardHeader.vue";
import EsgPartnerQuarterlyEmission from "./EsgPartnerQuarterlyEmission.vue";
import EsgPartnerDataGrid from "./EsgPartnerDataGrid.vue";
import EsgBaseCard from "@/components/esg/base/EsgBaseCard.vue";

export default {
  components: {
    EsgBaseCard,
    EsgCardHeader,
    EsgSingleScoreCard,
    EsgPartnerQuarterlyEmission,
    EsgPartnerDataGrid
  }
}
</script>
<style>
#esg-individual-partner-monitoring .wrap {
  padding: 0 !important;
  margin-top: 1em;
  margin-bottom: 1em;
}

#esg-individual-partner-monitoring {
  padding: 0 !important;
}
</style>